import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { FollowUpDate } from './follow-up-date.const';

/**
 * Renders a follow-up's `actionOn` as its business day. Deliberately takes no format or
 * timezone argument, so the rule cannot be applied half-way — see
 * `follow-up-date.const.ts` for why it exists. Every other date in HQ still belongs to
 * `azcMoment`; this pipe is only for `actionOn`.
 */
@Pipe({ name: 'azcFollowUpDate', pure: true })
export class FollowUpDatePipe implements PipeTransform {
	constructor( @Inject(LOCALE_ID) private _locale: string) { }

	transform(value: any): string | null {
		if (value == null || value === '') {
			return null;
		}

		return FollowUpDate.day(typeof value === 'string' ? value.trim() : value)
			.locale(this._locale)
			.format('D MMM YYYY');
	}
}
